import { createSelector } from 'reselect';
import { IAppState } from '../types/state.d';

export const httpSelector = (state: IAppState) => state.http;

type TInFlight = boolean | undefined;
export const getRequestInFlight = (requestName: string) =>
  createSelector(
    httpSelector,
    (http): TInFlight => http[requestName] && http[requestName].isInFlight,
  );

export const getRequestError = (requestName: string) =>
  createSelector(httpSelector, http =>
    Boolean(http[requestName] && http[requestName].isError),
  );

export const getRequestSuccess = (requestName: string) =>
  createSelector(httpSelector, http =>
    Boolean(http[requestName] && http[requestName].isSuccess),
  );
